"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Snackbar = core_1.Snackbar;
exports.default = Snackbar;
//# sourceMappingURL=Snackbar.js.map